import { EnvironmentConfiguration } from "./EnvironmentConfiguration";

class ConfigService {

  private _configuration: EnvironmentConfiguration;

  public async getConfiguration(): Promise<EnvironmentConfiguration> {

    if (this._configuration) return Promise.resolve(this._configuration);

    const response = await fetch("/physicianportal/config.json")
    this._configuration = await response.json();
    
    return this._configuration;
  }
}

export const configService = new ConfigService();